import { generateUniqueId } from '../../helpers/common';

export const SET_CREDENTIALS = generateUniqueId();
export const SET_PASSWORD = generateUniqueId();
export const SET_CONFIRM_PASSWORD = generateUniqueId();
export const SET_CONFIRM_PASSWORD_ERROR = generateUniqueId();
export const SET_ALERT_MESSAGE = generateUniqueId();
export const TOGGLE_ALIERT_DIALOG = generateUniqueId();
export const RESET_SUCCESS_FLAG = generateUniqueId();